import {
  HOUSE_SIT_HOUSE_PICKER,
  HOUSE_SITTER_DETAILS,
  HOUSE_SITTER_PHOTOS,
  HOUSE_SITTER_DESIRED_LOCATIONS,
  HOUSE_SITTER_PROPERTY_EXPERIENCE,
  HOUSE_SITTER_PET_CARE_EXPERIENCE,
  HOUSE_SITTER_REFERENCES_AND_REVIEWS,
  DETAILS,
  PRICING,
  PRICING_AND_STOCK,
  DELIVERY,
  LOCATION,
  AVAILABILITY,
  PHOTOS,
  PETS,
} from './editListingTabs';

/**
 * Check if a wizard tab is completed.
 *
 * This is the single source of truth for tab completeness. EditListingWizard uses it to enable
 * / grey out tabs; the ListingPage uses it to decide which tab to send a house sitter to when
 * they open the preview of a still-unpublished draft profile.
 *
 * @param tab wizard's tab
 * @param listing is contains some specific data if tab is completed
 *
 * @return true if tab / step is completed.
 */
export const tabCompleted = (tab, listing, config) => {
  const {
    availabilityPlan,
    description,
    geolocation,
    price,
    title,
    publicData,
    privateData,
  } = listing.attributes;
  const images = listing.images;
  const { desiredLocations,
    locationCharacteristics,
    publicTransportAccess,
    propertyMaintananceExperience,
    availableForCommunication,
    petCareExperience,
    listingType, transactionProcessAlias, unitType, shippingEnabled, pickupEnabled, houseListingId, } =
    publicData || {};
  const deliveryOptionPicked = publicData && (shippingEnabled || pickupEnabled);

  switch (tab) {
    case HOUSE_SIT_HOUSE_PICKER:
      return !!(title && houseListingId)
    case HOUSE_SITTER_DETAILS:
      return !!(
        description &&
        title &&
        listingType &&
        transactionProcessAlias &&
        unitType
      );
    case HOUSE_SITTER_PHOTOS:
      return images && images.length > 0;
    case HOUSE_SITTER_DESIRED_LOCATIONS:
      return !!(desiredLocations &&
        locationCharacteristics &&
        publicTransportAccess);
    case HOUSE_SITTER_PROPERTY_EXPERIENCE:
      return !!(propertyMaintananceExperience &&
        availableForCommunication);
    case HOUSE_SITTER_PET_CARE_EXPERIENCE:
      return !!(petCareExperience);
    case HOUSE_SITTER_REFERENCES_AND_REVIEWS:
      // Reviews/references are optional — a sitter may be new or simply have none yet, so this
      // tab is always considered complete and never blocks publishing.
      return true;
    case DETAILS:
      return !!(
        description &&
        title &&
        listingType &&
        transactionProcessAlias &&
        unitType
        // hasValidListingFieldsInExtendedData(publicData, privateData, config)
      );
    case PRICING:
      return !!price;
    case PRICING_AND_STOCK:
      return !!price;
    case DELIVERY:
      return !!deliveryOptionPicked;
    case LOCATION:
      return !!(geolocation && (geolocation.lat !== 0 || geolocation.lng !== 0) && publicData?.location?.address);
    case AVAILABILITY:
      return !!availabilityPlan;
    case PHOTOS:
      return images && images.length > 0;
    case PETS:
      return true;
    default:
      return false;
  }
};
